import { isInExtension } from '../extension'
import window from '../injectChromeObject'

export function getResourceFile(path) {
  return isInExtension() ? window.chrome?.runtime?.getURL(path) || '' : path
}
